import { gql, type QueryHookOptions, useQuery } from "@apollo/client";

const QUERY = gql`
  {
    wrapped {
      escapeRoomsDone
      hauntsDone
      hoursSpent
      citiesVisited
      badgesEarned
    }
  }
`;

export interface WrappedType {
  badgesEarned?: number;
  citiesVisited?: number;
  escapeRoomsDone?: number;
  hauntsDone?: number;
  hoursSpent?: number;
}

interface DataType {
  wrapped: WrappedType;
}

export default function useWrapped(options?: QueryHookOptions<DataType>) {
  return useQuery<DataType>(QUERY, options);
}
